import { createStore } from 'vuex'

import * as getters from './getters'
import mutations from './mutations'
import actions from './actions'

import auth from './modules/auth/index'
import user from './modules/user/index'
import nps from './modules/nps/index'
import restaurant from './modules/restaurant/index'
import timezone from './modules/timezone/index'
import category from './modules/category/index'
import meal from './modules/meal/index'
import attributs from './modules/attributs/index'
import variation from './modules/variations/index'
import accompaniment from './modules/accompaniment/index'
import right from './modules/right/index'
import room from './modules/room/index'
import table from './modules/table/index'
import perimeter from './modules/perimeter/index'
import order from './modules/order/index'
import permission from './modules/permission/index'
import reservation from './modules/reservation/index'

const initialState = {
  isAppLoaded: false,
  callTables : []
}


export default createStore({

  state: initialState,

  getters,
  mutations,
  actions,

  modules: {
    auth,
    user,
    nps,
    restaurant,
    timezone,
    category,
    attributs,
    variation,
    accompaniment,
    right,
    room,
    table,
    order,
    perimeter,
    meal,
    permission,
    reservation
  }
})

